export enum ContentsCalculatorRooms {
    sittingRoom = "Sitting Room/Lounge",
    diningRoom = "Dining Room",
    kitchen = "Kitchen",
    bedrooms = "Bedrooms",
    bathrooms = "Bathrooms",
    garden = "Garden/Garage/Shed",
    extraRoom = "Extra Room, e.g. home office/study/cellar",
    attic = "Attic/Loft/Storage",
}
